import React from "react";

const TabButton = ({ tab, onClick, isActive }) => {
  return (
    <button
      type="button"
      className={`text-themeBlack whitespace-nowrap block flex-shrink-0 text-sm font-medium leading-normal ${
        isActive ? "text-themeSecondColor" : "text-themeBlack hover:bg-gray-100"
      }`}
      onClick={() => onClick(tab.id)}
    >
      {tab.label}
    </button>
  );
};

export default TabButton;
